import { memo, useEffect, useRef } from "react";

const CONFIG = {
    symbols: [
        { proName: "FX:EURUSD", title: "EUR/USD" },
        { proName: "FX:GBPUSD", title: "GBP/USD" },
        { proName: "FX:USDJPY", title: "USD/JPY" },
        { proName: "TVC:GOLD", title: "Gold" },
        { proName: "TVC:SILVER", title: "Silver" },
        { proName: "TVC:USOIL", title: "WTI Crude" },
        { proName: "FOREXCOM:SPXUSD", title: "S&P 500" },
        { proName: "FOREXCOM:NSXUSD", title: "Nasdaq 100" },
        { proName: "AMEX:SPY", title: "SPY" },
        { proName: "NASDAQ:QQQ", title: "QQQ" },
        { proName: "AMEX:GLD", title: "GLD" },
    ],
    showSymbolLogo: true,
    isTransparent: true,
    displayMode: "adaptive",
    colorTheme: "dark",
    locale: "en",
};

const TickerTape = memo(function TickerTape() {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el || el.dataset.loaded === "1") return;
        el.dataset.loaded = "1";
        el.innerHTML = "";
        const widget = document.createElement("div");
        widget.className = "tradingview-widget-container__widget";
        el.appendChild(widget);
        const script = document.createElement("script");
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
        script.async = true;
        script.type = "text/javascript";
        script.innerHTML = JSON.stringify(CONFIG);
        el.appendChild(script);
    }, []);

    return (
        <div
            ref={ref}
            data-testid="ticker-tape"
            className="tradingview-widget-container w-full border-y border-white/10 bg-black/30"
        />
    );
});

export default TickerTape;
